import template   from './home-description.html'
import controller from './home-description.controller'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/home/description/home-description.component.js